module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "stars",
    on: {
      "mouseleave": function($event) {
        _vm.hover = 0
      },
      "click": function($event) {
        return _vm.$emit('click', _vm.hover)
      }
    }
  }, _vm._l((_vm.stars), function(star, index) {
    return _c('li', {
      staticClass: "star star",
      on: {
        "mouseover": function($event) {
          _vm.hover = index + 1
        }
      }
    }, [(star) ? _c('img', {
      attrs: {
        "src": require("./star-active.svg")
      }
    }) : _c('img', {
      attrs: {
        "src": require("./star.svg")
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ad4f12","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/rating/default/Default.vue
// module id = 269bc036b76c15884a43
// module chunks = 0